import type { PublicationCategory } from '../types/common';

type Category = {
  label: string;
  value: PublicationCategory;
  color: 'default' | 'secondary' | 'outline';
  /** Предлагается ли при публикации. Прежние типы только показываются у старых записей. */
  selectable: boolean;
};

export const PUBLICATION_CATEGORIES: Record<PublicationCategory, Category> = {
  editorial: { label: 'Редакция', value: 'editorial', color: 'outline', selectable: true },
  b2g: { label: 'B2G', value: 'b2g', color: 'secondary', selectable: true },
  b16: { label: 'Реклама bee16', value: 'b16', color: 'default', selectable: true },
  akimat: { label: 'Акимат', value: 'akimat', color: 'outline', selectable: true },
  advertising: { label: 'Рекламный', value: 'advertising', color: 'default', selectable: false },
  partner: { label: 'Партнерский', value: 'partner', color: 'secondary', selectable: false },
  ai_ugc: { label: 'AI UGC', value: 'ai_ugc', color: 'default', selectable: false },
};

/** Типы для выбора при публикации, в порядке частоты. */
export const SELECTABLE_CATEGORIES = Object.values(PUBLICATION_CATEGORIES).filter((c) => c.selectable);

/**
 * Тип по умолчанию: ролик, взятый в «Роликах B2G», — B2G, всё остальное —
 * свой ролик редакции. Сменить можно одним нажатием.
 */
export const defaultCategory = (fromB2GTake: boolean): PublicationCategory => (fromB2GTake ? 'b2g' : 'editorial');

export const getCategoryLabel = (category?: PublicationCategory): string => {
  if (!category) return '';
  return PUBLICATION_CATEGORIES[category]?.label || '';
};

export const getCategoryColor = (category?: PublicationCategory): 'default' | 'secondary' | 'outline' => {
  if (!category) return 'default';
  return PUBLICATION_CATEGORIES[category]?.color ?? 'default';
};
